import React from 'react'
import { getHexColor, IconColor } from '../utils'

interface DeprecatedIconProps {
  className?: string
  color?: IconColor
  size?: number
  height?: number
  width?: number
  onClick?: React.MouseEventHandler<SVGSVGElement>
}

/**
 * @deprecated Use the CaretLeftIcon instead.
 */
export const ChevronLeftIcon: React.FC<DeprecatedIconProps> = ({
  width = 9,
  height = 14,
  size,
  color = 'white',
  className,
  onClick,
}) => {
  return (
    <svg
      data-testid="chevron-left-icon"
      width={size ?? width}
      height={size ?? height}
      viewBox="0 0 9 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
    >
      <path d="M8 1L2 7L8 13" stroke={getHexColor(color)} strokeWidth="2" strokeLinecap="round" />
    </svg>
  )
}
